export const EXCMUSERDATAWORKPLACE_CREATE_RESET = 'EXCMUSERDATAWORKPLACE_CREATE_RESET'
export const EXCMUSERDATAWORKPLACE_CREATE_SET_CREATED = 'EXCMUSERDATAWORKPLACE_CREATE_SET_CREATED'
export const EXCMUSERDATAWORKPLACE_CREATE_SET_ERROR = 'EXCMUSERDATAWORKPLACE_CREATE_SET_ERROR'
export const EXCMUSERDATAWORKPLACE_CREATE_SET_VIOLATIONS = 'EXCMUSERDATAWORKPLACE_CREATE_SET_VIOLATIONS'
export const EXCMUSERDATAWORKPLACE_CREATE_TOGGLE_LOADING = 'EXCMUSERDATAWORKPLACE_CREATE_TOGGLE_LOADING'
